import { useEffect, useState, useMemo } from 'react';
import axios from "axios";

import * as helpers from "../utils/utils.js"
import { useClientId } from "../context/context.js";

export function usePrices() {
  const clientId = useClientId();

  const retrievePrices = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/clients/${clientId}/prices`,
    );
    return response.data;
  };

  const retrievePriceById = async (id) => {
    const { data } = await axios.get(
      process.env.REACT_APP_API_URL + `/clients/${clientId}/prices/${id}`,
    );
    return { ...data, id };
  };
      
  return {
    retrievePrices,
    retrievePriceById,
  };
}
